export const ROLE_LABELS = {
  gerant: 'Gérant',
  directeur: 'Directeur',
  inspecteur: 'Inspecteur',
  agent_ecole: 'Agent administratif',
  agent_college: 'Agent administratif collège',
  associe: 'Associé'
};

export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard.view',
  REGISTRATIONS_VIEW: 'registrations.view',
  REGISTRATIONS_MANAGE: 'registrations.manage',
  STUDENTS_VIEW: 'students.view',
  STUDENTS_MANAGE: 'students.manage',
  PARENTS_VIEW: 'parents.view',
  PARENTS_MANAGE: 'parents.manage',
  PARENTS_ACCOUNT_ADMIN: 'parents.account_admin',
  EMPLOYEES_VIEW: 'employees.view',
  EMPLOYEES_MANAGE: 'employees.manage',
  CLASSES_VIEW: 'classes.view',
  CLASSES_MANAGE: 'classes.manage',
  CLASSES_RESULTS_VIEW: 'classes.results_view',
  FINANCE_STUDENT_LOOKUP: 'finance.student_lookup',
  FINANCE_PAYMENT_CREATE: 'finance.payment_create',
  FINANCE_PAYMENT_UPDATE: 'finance.payment_update',
  FINANCE_PAYMENT_CANCEL: 'finance.payment_cancel',
  FINANCE_PAYMENT_DELETE: 'finance.payment_delete',
  FINANCE_RECEIPT: 'finance.receipt',
  FINANCE_CONTRACTS_MANAGE: 'finance.contracts_manage',
  FINANCE_GLOBAL_VIEW: 'finance.global_view',
  CASH_OWN_VIEW: 'cash.own.view',
  CASH_SUBMIT: 'cash.submit',
  CASH_CONFIRM: 'cash.confirm',
  TASKS_VIEW: 'tasks.view',
  TASKS_MANAGE: 'tasks.manage',
  COMMUNICATION_VIEW: 'communication.view',
  COMMUNICATION_SEND: 'communication.send',
  HR_VIEW: 'hr.view',
  DOCUMENTS_VIEW: 'documents.view',
  REPORTS_VIEW: 'reports.view',
  HOMEWORK_VALIDATE: 'homework.validate',
  SCHOOL_SUPPLIES_MANAGE: 'school_supplies.manage',
  SETTINGS_MANAGE: 'settings.manage'
};

const ALL = Object.values(PERMISSIONS);

export const DEFAULT_ROLE_PERMISSIONS = {
  gerant: ALL,

  // Les autres rôles restent conservés pour compatibilité. La matrice finale
  // du projet doit être utilisée avant leur activation en production.
  directeur: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.STUDENTS_VIEW,
    PERMISSIONS.CLASSES_VIEW,
    PERMISSIONS.CLASSES_RESULTS_VIEW,
    PERMISSIONS.COMMUNICATION_VIEW
  ],
  inspecteur: [
    PERMISSIONS.STUDENTS_VIEW,
    PERMISSIONS.CLASSES_VIEW,
    PERMISSIONS.CLASSES_RESULTS_VIEW
  ],

  // "Agent école" de la matrice = "Agent administratif" dans l'interface.
  // Aucun accès Personnel/RH, paramètres, rapports financiers ou finance globale.
  agent_ecole: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.REGISTRATIONS_VIEW,
    PERMISSIONS.REGISTRATIONS_MANAGE,
    PERMISSIONS.STUDENTS_VIEW,
    PERMISSIONS.STUDENTS_MANAGE,
    PERMISSIONS.PARENTS_VIEW,
    PERMISSIONS.PARENTS_MANAGE,
    PERMISSIONS.CLASSES_VIEW,
    PERMISSIONS.FINANCE_STUDENT_LOOKUP,
    PERMISSIONS.FINANCE_PAYMENT_CREATE,
    PERMISSIONS.FINANCE_PAYMENT_UPDATE,
    PERMISSIONS.FINANCE_PAYMENT_CANCEL,
    PERMISSIONS.FINANCE_RECEIPT,
    PERMISSIONS.FINANCE_CONTRACTS_MANAGE,
    PERMISSIONS.CASH_OWN_VIEW,
    PERMISSIONS.CASH_SUBMIT,
    PERMISSIONS.TASKS_VIEW,
    PERMISSIONS.TASKS_MANAGE,
    PERMISSIONS.COMMUNICATION_VIEW,
    PERMISSIONS.COMMUNICATION_SEND,
    PERMISSIONS.SCHOOL_SUPPLIES_MANAGE
  ],

  agent_college: [
    PERMISSIONS.FINANCE_STUDENT_LOOKUP,
    PERMISSIONS.FINANCE_PAYMENT_CREATE,
    PERMISSIONS.FINANCE_PAYMENT_UPDATE,
    PERMISSIONS.FINANCE_PAYMENT_CANCEL,
    PERMISSIONS.FINANCE_RECEIPT
  ],

  associe: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.STUDENTS_VIEW,
    PERMISSIONS.PARENTS_VIEW,
    PERMISSIONS.EMPLOYEES_VIEW,
    PERMISSIONS.CLASSES_VIEW,
    PERMISSIONS.FINANCE_GLOBAL_VIEW,
    PERMISSIONS.REPORTS_VIEW,
    PERMISSIONS.COMMUNICATION_VIEW
  ]
};

export function resolvePermissions(profile) {
  const rawRoles = profile?.adminRoles ?? profile?.adminRole ?? profile?.role ?? [];
  const roles = Array.isArray(rawRoles) ? rawRoles : [rawRoles].filter(Boolean);
  const normalizedRoles = roles.map((role) => {
    const value = String(role || '').trim().toLowerCase();
    if (value === 'admin' || value === 'administration') return 'gerant';
    if (value === 'agent_administratif' || value === 'agent administratif') return 'agent_ecole';
    return value;
  });
  const resolved = new Set();

  normalizedRoles.forEach((role) => {
    const rolePermissions = DEFAULT_ROLE_PERMISSIONS[role] || [];
    rolePermissions.forEach((permission) => resolved.add(permission));
  });

  Object.entries(profile?.customPermissions || {}).forEach(([permission, allowed]) => {
    if (allowed === true) resolved.add(permission);
    else if (allowed === false) resolved.delete(permission);
  });

  return resolved;
}
